import { render, staticRenderFns } from "./printCredentials.vue?vue&type=template&id=2f2ea281&scoped=true&"
import script from "./printCredentials.vue?vue&type=script&lang=js&"
export * from "./printCredentials.vue?vue&type=script&lang=js&"
import style0 from "./printCredentials.vue?vue&type=style&index=0&id=2f2ea281&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2ea281",
  null
  
)

export default component.exports